import { ChangeUserProfileItemStore, NewProfileItemAssigmentStore, UserProfilesStore } from './user-profile-store';
import { UploadUserProfileAssignmentsStore } from './user-profile-upload-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new ChangeUserProfileItemStore());
  storeBuilder.addRepository(new NewProfileItemAssigmentStore());
  storeBuilder.addRepository(new UserProfilesStore());
  storeBuilder.addRepository(new UploadUserProfileAssignmentsStore());
}
